module.exports = __webpack_public_path__ + "static/media/bubble1.dc07eef5.png";